import { render, staticRenderFns } from "./rkxxx-transfer.vue?vue&type=template&id=fa3c38e4&"
import script from "./rkxxx-transfer.vue?vue&type=script&lang=ts&"
export * from "./rkxxx-transfer.vue?vue&type=script&lang=ts&"
import style0 from "./rkxxx-transfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports